import request from '@/router/axios'
import env from '@/config/env'

/**
 * 添加计价价规则
 * @param data
 */
export const addRules = (data) => {
  return request({
    url: env.ferryUrl + '/priceTypeManage/save',
    method: 'POST',
    data: data
  })
}

/**
 * 修改计价规则
 * @param data
 */
export const updated = (data) => {
  return request({
    url: env.ferryUrl + '/priceTypeManage/update',
    method: 'PUT',
    data: data
  })
}

/**
 * 列表
 * @param data
 */
export const list = (data) => {
  return request({
    url: env.ferryUrl + '/priceTypeManage/list',
    method: 'POST',
    data: data
  })
}


/**
 * 删除
 * @param id
 */
export const deleted = (id) => {
  return request({
    url: env.ferryUrl + `/priceTypeManage/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 获取详情
 * @param id
 */
export const getInfo = (id) => {
  return request({
    url: env.ferryUrl + `/priceTypeManage/selectById/${id}`,
    method: 'POST'
  })
}

/**
 * 获取计价模型列表
 * @param data
 */
export const listModel = (data) => {
  return request({
    url: env.ferryUrl + '/priceModuleManage/list',
    method: 'post',
    data: data
  })
}

/**
 * 保存计价模型
 * @param data
 */
export const saveModel = (data) => {
  return request({
    url: env.ferryUrl + '/priceModuleManage/save',
    method: 'post',
    data: data
  })
}

/**
 * 编辑计价模型
 * @param data
 */
export const updateModel = (data) => {
  return request({
    url: env.ferryUrl + '/priceModuleManage/update',
    method: 'PUT',
    data: data
  })
}

/**
 * 获取详情
 * @param id
 */
export const getModelInfo = (id) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/selectById/${id}`,
    method: 'POST'
  })
}

/**
 * 删除模型
 * @param id
 */
export const deletedModel = (id) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/delete/${id}`,
    method: 'DELETE'
  })
}

/**
 * 先获取省市区再查询
 * @param query
 */
export const getStationItem = (areaManageId) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/stationList/${areaManageId}`,
    method: 'post'
  })
}

/**
 * 根据先获取省市区编码在查询
 * @param code
 */
export const getServiceAreaItem = (areaManageId) => {
  return request({
    url: env.ferryUrl + `/priceModuleManage/serviceAreaList/${areaManageId}`,
    method: 'post'
  })
}

/**
 * 批量删除
 * @param ids
 */
export const deletes = (ids) => {
  return request({
    url: env.ferryUrl + '/priceModuleManage/deleteBatch',
    method: 'POST',
    data: {
      id: ids
    }
  })
}

/**
 * 绑定供应商
 * @param data
 */
export const bindMerchante = (data) => {
  return request({
    url: env.ferryUrl + '/priceModuleManage/bindMerchant',
    method: 'POST',
    data: data
  })
}

